<template>
  <div class="special-sale-nav" ref="specialSalelNav">
    <van-tabs
      :border="false"
      :ellipsis="false"
      :lazy-render="true"
      :offset-top="navHeight"
      :sticky="true"
      :style="{ minHeight: clientHeight + 'px' }"
      @change="switchTab"
      class="choose-goods-tabs"
      color="#FF7636"
      title-active-color="#404040"
      title-inactive-color="#404040"
      v-model="current"
    >
      <van-tab :key="index" :title="nav.title" class="tab-item" v-for="(nav, index) in navList">
        <div class="container">
          <div class="product-lists" v-show="index === current">
            <div class="tab-content">
              <cont-item :gid="gid" :sku-list="contList" @change="changeHandler">
                <template #filter>
                  <div class="functional-bar van-hairline--top-bottom">
                    <div class="goods-num-desc">
                      当前档
                      <em>{{contList.length}}</em> 件商品加入信用购
                    </div>
                    <div class="goods-filters">
                      <span></span>
                      <dropdown-menu active-color="#2ECC71">
                        <dropdown-item :options="option" v-model="value" />
                      </dropdown-menu>
                    </div>
                  </div>
                </template>
              </cont-item>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, DropdownMenu, DropdownItem } from 'vant'
import api from '../../utils/api'
import ContItem from './ChooseGoodsItem'
let flag = false
let timer = null
export default {
  name: 'chooseGoodsNav',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    ContItem,
    DropdownMenu,
    DropdownItem
  },
  props: {
    navList: {
      type: Array
    },
    navHeight: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      value: 'a',
      option: [
        { text: '全部商品', value: 'a' },
        { text: '佣金由高到低', value: 'b' },
        { text: '仅显示已选商品', value: 'c' },
        { text: '仅显示未选商品', value: 'd' },
        { text: '仅显示0元购', value: 'e' }
      ],
      current: 0,
      loading: false,
      finished: false,
      contList: [],
      noData: false,
      transBg: 'transparent'
    }
  },
  computed: {
    clientHeight () {
      return document.documentElement && document.documentElement.clientHeight
    },
    gid () {
      return this.navList.length && this.navList[this.current].id
    }
  },
  watch: {
    current (newVal) {
      this.contList = []
      this.catPriceList = []
      this.finished = false
      clearTimeout(timer)
      this.value = 'a'
      timer = setTimeout(() => {
        this.getGoodsListHandler(this.navList[this.current].id)
      }, 150)
    }
  },
  methods: {
    /**
     * 分页加载
     */
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {

      }, 150)
    },

    /**
     * 导航切换
     */
    switchTab (i) {
      // this.navItemBanner = this.navList[this.current].img_url
      // this.$toast.loading()
    },

    /**
     * 商品操作
     * @param { String } id skuid
     * @param {Boolean | Number} status sku选中状态 0 false, 1 true
     */
    changeHandler ({ id, status }) {
      if (status) {
        this.delGoods(id)
      } else {
        this.addGoods(id)
      }
    },

    /**
     * 添加商品
     */
    async addGoods (id) {
      this.$toast.loading('请稍后...')
      const res = await this.$axios.post('api/business/c', { gid: this.gid, sku_id: id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('加入成功')
          this.editGoodsHandler(id, true)
        } else {
          this.$toast(msg)
          this.editGoodsHandler(id, false)
        }
      }
    },

    /**
     * 删除商品
     */
    async delGoods (id) {
      this.$toast.loading('请稍后...')
      const res = await this.$axios.post('api/business/dc', { gid: this.gid, sku_id: id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('移除成功')
          this.editGoodsHandler(id, false)
        } else {
          this.$toast(msg)
          this.editGoodsHandler(id, true)
        }
      }
    },

    /**
     * 数据更新操作
     */
    editGoodsHandler (id, status) {
      this.contList = this.contList.map(v => {
        if (v.sku_id === id) {
          v.status = status
        }
        return v
      })
    },

    /**
      *获取列表封装
     */
    async getGoodsListHandler (id) {
      const data = await api.getActGoodsList(id)
      if (data.length) {
        this.contList = data
      } else {
        this.noData = true
      }
      this.finished = true
    }

  }
}
</script>
<style lang="less">
.choose-goods-tabs {
  .van-sticky {
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.22);
  }
  .van-tabs__wrap {
    // padding-bottom: 0.1rem;
  }
  .vant-tab,
  .van-tab--active {
    font-size: 0.26rem !important;
    font-weight: bold !important;
  }
}
.functional-bar {
  .van-dropdown-menu {
    height: 0.86rem;
    font-size: @fz22;
    &::after,
    &::before {
      border: none;
    }
  }
  .van-dropdown-menu__title,
  .van-cell {
    font-size: @fz22;
  }
}
</style>
<style lang="less">
.functional-bar {
  margin-top: 0.02rem;
  font-size: @fz22;
  height: 0.86rem;
  .flex-between;
  padding-left: 0.2rem;
  padding-right: 0.3rem;
  background-color: #fff;
  em {
    color: #ff4f4f;
  }
  &::after {
    z-index: 999;
  }
}
</style>
